// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.7.1_webpack@5.89.0/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.7.1_webpack@5.89.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".RecentEventsTrackingRedirect-module__modalDialog--XCw5Y{max-width:35rem}.RecentEventsTrackingRedirect-module__content--zYCPW{font-size:.75rem}.RecentEventsTrackingRedirect-module__graphic--jM2Am{display:block;margin-left:25%;margin-top:2rem;margin-bottom:2rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalDialog": "RecentEventsTrackingRedirect-module__modalDialog--XCw5Y",
	"content": "RecentEventsTrackingRedirect-module__content--zYCPW",
	"graphic": "RecentEventsTrackingRedirect-module__graphic--jM2Am"
};
export default ___CSS_LOADER_EXPORT___;
